/*
 * Copyright (c) Nexign, JSC, 1992-2025.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Dmitriy Kvon
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { button, colors, fonts } from '@theme/index';

interface IPageStyledProps {
    iconLeft?: string;
}

const titleIconSize = 24;

const PageContainerStyled = styled.div.attrs({
    className: 'page-title',
})`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 8px 0 24px;
    align-items: self-start;

    & .page-title__button .button__button-content:focus:not(:hover) {
        background: none;
    }
    & .page-title__button .button__button-content {
        margin-bottom: 0;
        margin-top: 0;
    }
    .page-title__settings:only-child {
      margin-left: auto;
    }
`;

const TitleStyled = styled.div.attrs({
    className: 'page-title__title',
})`
    display: flex;
    align-items: center;
    ${fonts.textHeader3};
    margin-bottom: 0;
`;

const TitleDivStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: baseline;
`

const Counter = styled.span.attrs({
    className: 'page-title__counter',
})`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 28px;
    height: 28px;
    margin-left: 8px;
    padding: 0 6px;
    box-sizing: border-box;
    border-radius: 15.5px;
    background-color: ${colors.backgroundColorModal};
    text-align: center;
    ${fonts.textMain};
`;

const SettingsStyled = styled.div.attrs({
    'className': 'page-title__settings',
    'data-name': 'pageTitleSettings',
})`
    display: flex;
    justify-content: space-between;
    line-height: 1;
    padding-right: 2px;

    & .page-title__drop-filter-btn .text-block {
        line-height: 1;
    }

    .page-title__button button {
        display: block;
    }

    & .page-title__button .button__button-content,
    & .page-title__refresh-button .button__button-content {
        display: flex;
        align-items: center;
        height: 32px;
    }
    .page-title__block-with-icon  {
        cursor: pointer;
    }
    .page-title__refresh-button .button__button-content  {
        display: block;
        padding: ${button.padding};
    }
    .button__button-content  {
        background-color:  ${colors.tableTitleButtonBgColor};

        &:hover {
            background-color:  ${colors.tableTitleButtonBgColorHover};
        }
    }

    .button__button-content_export {
        button {
            &:hover {
                background-color: ${colors.backgroundColorHover};
            }
        }
    }
`;

const PagePanelButtonTextStyled = styled.span`
    ${fonts.textSmall};

    margin-left: 4px;
`;

const PagePanelButtonSelectStyled = styled.div<IPageStyledProps>`
        .select__select-drop-button {
        box-sizing: border-box;
        height: 32px;
        border-color: transparent;
        border-radius: 1rem;

        span {
            opacity: 1;
        }
        &:not(.disabled):focus,
        &:not(.disabled):hover {
            outline: none;
            background-color: ${colors.backgroundColorHoverNormal};
        }

        &:active {
            background-color: ${colors.backgroundColorActiveSettings};
        }

        &.disabled {
            cursor: default;
        }
        &::before {
            content: "";
            height: ${(props) => props.iconLeft ? titleIconSize : 0}px;
            width: ${(props) => props.iconLeft ? 28 : 0}px;
            background: url(${(props) => props.iconLeft}) no-repeat;
            background-size: ${titleIconSize}px ${titleIconSize}px;
        }
        &::after {
            right: 6px;
        }
    }
    .drop-down-filter_opened {
        .select__select-drop-button {
            background-color: ${colors.backgroundColorHoverNormal};
        }
    }
`;

export {
    Counter,
    PageContainerStyled,
    PagePanelButtonSelectStyled,
    PagePanelButtonTextStyled,
    SettingsStyled,
    titleIconSize,
    TitleStyled,
    TitleDivStyled,
};
